import { render } from "./map-167.vue?vue&type=template&id=99980026"
import script from "./map-167.vue?vue&type=script&lang=js"
export * from "./map-167.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__